<template>
  <div id="instrument-inputs">
    <div style="display: flex;">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>导入总台账</span>
        </div>
        <el-upload
          class="upload-demo"
          ref="upload"
          :action="updateAction"
          name="avatar"
          :on-change="(file,fileList) => uploadFileChange(file,fileList,'machines')"
          :auto-upload="false"
          :on-success="(response, file, fileList) => uploadResult(response, file, fileList,'machines')"
          :show-file-list="false"
          drag
          :limit="1">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <!-- <div>
            <el-button slot="trigger" style="color: #fff" size="small" type="text">导入总台账</el-button>
          </div> -->
        </el-upload>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>导入借出设备</span>
        </div>
        <el-upload
          class="upload-demo"
          ref="operateUpload"
          :action="updateOperateAction"
          name="operate"
          :on-change="(file,fileList) => uploadFileChange(file,fileList,'operate')"
          :auto-upload="false"
          :on-success="(response, file, fileList) => uploadResult(response, file, fileList,'operate')"
          :show-file-list="false"
          drag
          :limit="1">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <!-- <div>
            <el-button slot="trigger" style="color: #fff" size="small" type="text">导入总台账</el-button>
          </div> -->
        </el-upload>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>导入计量</span>
        </div>
        <el-upload
          class="upload-demo"
          ref="verificationUpload"
          :action="updateVerificationAction"
          name="verification"
          :on-change="(file,fileList) => uploadFileChange(file,fileList,'verification')"
          :auto-upload="false"
          :on-success="(response, file, fileList) => uploadResult(response, file, fileList,'verification')"
          :show-file-list="false"
          drag
          :limit="1">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <!-- <div>
            <el-button slot="trigger" style="color: #fff" size="small" type="text">导入总台账</el-button>
          </div> -->
        </el-upload>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'instrument-inputs',
  data() {
    return {
      updateAction: this.$equipmentdata.pre_url + "/importMachines",
      updateOperateAction: this.$equipmentdata.pre_url + "/importOperation",
      updateVerificationAction: this.$equipmentdata.pre_url + "/importVerification",
    }
  },
  mounted(){
    
  },
  methods: {
    uploadFileChange(file,fileList,type){
      if(fileList.length !== 0){
        this.$confirm('是否上传文件,文件内容过多可能导致等待时间过长！' + file.name, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.uploading = this.$loading({
            lock: true,
            text: '拼命加载中...',
          });
          if(type === 'machines')
            this.$refs.upload.submit();
          else if(type === 'operate')
            this.$refs.operateUpload.submit();
          else if(type === 'verification')
            this.$refs.verificationUpload.submit();
        }).catch(() => {
          if(type === 'machines')
            this.$refs.upload.clearFiles();
          else if(type === 'operate')
            this.$refs.operateUpload.clearFiles();
          else if(type === 'verification')
            this.$refs.verificationUpload.clearFiles();
        });
      }
    },

    uploadResult(response, file, fileList,type){
      this.$refs.upload.clearFiles();
      this.$refs.operateUpload.clearFiles();
      this.$refs.verificationUpload.clearFiles();
      //console.log(response);
      this.uploading.close();
      if(type === 'machines'){
        this.$message({type: 'success',message: '上传成功!'});
      }
      else if(type === 'operate'){
        if(response.length === 0)
          this.$message({type: 'success',message: '上传成功!'});
        else
          this.$message({type: 'warning',message: response.join(',') + ' 等设备处于非在用状态'});
      }
      else if(type === 'verification'){
        this.$message({type: 'success',message: '上传成功!'});
      }
    },
  }
}
</script>
<style>
html,body{
  margin: 0;
  height: 100%;
}
#instrument-inputs{
  position: relative;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/instrument/Inputs.vue